module.exports = __webpack_public_path__ + "static/media/pointer.8ec1296d.svg";